import { getEnvFlags } from '../env';
import { createLogger } from './logger';
const logger = createLogger('perf-utils');
const startMark = 'START_MARK-';
const endMark = 'END_MARK-';
const getPerformanceObj = () => {
    const envFlags = getEnvFlags();
    const isDebugMode = envFlags.isDebugMode;
    if (!isDebugMode || typeof performance === 'undefined') {
        return null;
    }
    return performance;
};
const mark = (markk) => {
    const performance = getPerformanceObj();
    if (!performance) {
        return null;
    }
    return performance.mark(markk);
};
const clearMarks = (names = []) => {
    const performance = getPerformanceObj();
    if (!performance) {
        return null;
    }
    if (!names.length) {
        performance.clearMarks();
    }
    names.forEach(name => {
        performance.clearMarks(name);
    });
    return null;
};
const measure = (measureName, startMarkk, endMarkk) => {
    try {
        const performance = getPerformanceObj();
        if (!performance) {
            return null;
        }
        performance.measure(measureName, startMarkk, endMarkk);
    }
    catch (e) {
        logger.debug(e);
    }
    return null;
};
const clearMeasures = (names = []) => {
    const performance = getPerformanceObj();
    if (!performance) {
        return null;
    }
    if (!names.length) {
        performance.clearMeasures();
    }
    names.forEach(name => {
        performance.clearMeasures(name);
    });
    return null;
};
const logMeasures = (data, name = '') => {
    if (!data) {
        return;
    }
    logger.debug('Measure', name, data);
};
const getEntriesByName = (name, type) => {
    const performance = getPerformanceObj();
    if (!performance) {
        return null;
    }
    return performance.getEntriesByName(name, type);
};
const measureBlock = (name, callback, options = {
    disableLogging: false,
    clearEntriesForMeasure: true,
}) => {
    const performance = getPerformanceObj();
    if (!performance) {
        return callback();
    }
    const sMark = startMark + name;
    const eMark = endMark + name;
    mark(sMark);
    const result = callback();
    mark(eMark);
    measure(name, sMark, eMark);
    if (!(options === null || options === void 0 ? void 0 : options.disableLogging)) {
        logMeasures(getEntriesByName('measure'), name);
    }
    if (options === null || options === void 0 ? void 0 : options.clearEntriesForMeasure) {
        clearMarks([sMark, eMark]);
        clearMeasures([name]);
    }
    return result;
};
const measureBlockAsync = async (name, callback, options = {
    disableLogging: false,
    clearEntriesForMeasure: true,
}) => {
    const performance = getPerformanceObj();
    if (!performance) {
        return await callback();
    }
    const sMark = startMark + name;
    const eMark = endMark + name;
    mark(sMark);
    const result = await callback();
    mark(eMark);
    measure(name, sMark, eMark);
    if (!(options === null || options === void 0 ? void 0 : options.disableLogging)) {
        logMeasures(getEntriesByName(name, 'measure'), name);
    }
    if (options === null || options === void 0 ? void 0 : options.clearEntriesForMeasure) {
        clearMarks([sMark, eMark]);
        clearMeasures([name]);
    }
    return result;
};
const cleanPeformanceEntries = () => {
    const performance = getPerformanceObj();
    if (!performance) {
        return null;
    }
    clearMeasures();
    clearMarks();
    return null;
};
export { getPerformanceObj, measureBlock, mark, measure, logMeasures, measureBlockAsync, cleanPeformanceEntries, clearMarks, clearMeasures, getEntriesByName, };
//# sourceMappingURL=perf-utils.js.map